// Utils
import { Typography } from '@components/typography';

type Props = {
  title: string;
  bodyRaw: string;
};

export const SerpParagraph: React.FC<Props> = ({ title, bodyRaw }) => {
  return (
    <div className="block sm:flex flex-row w-full sm:flex-col-2 py-4 sm:py-6 space-y-2 sm:space-y-0 sm:space-x-8">
      <div className="flex flex-col w-full lg:w-1/3 py-4 sm:py-0">
        <Typography component="h3" variant="title4">
          {title}
        </Typography>
      </div>
      <div className="flex flex-col w-full lg:w-2/3 pb-4 sm:pb-0">
        <li>
          <p style={{ whiteSpace: 'pre-line' }}>{bodyRaw}</p>
        </li>
      </div>
    </div>
  );
};
